module.exports = __webpack_public_path__ + "ed7adf67c00333bb7ea3a628ec3cb4f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/order.png
// module id = 487
// module chunks = 0